// auth/authUtils.js
import { DataService } from "./DataService";
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { DashboardAppConfig } from "../pages/Dashboard/DashboardAppConfig";

export const useRoleCheckDashboard = (pageKey) => {
    const navigate = useNavigate();

    useEffect(() => {
        const userRoles = DataService.getUserRoles();
        const pageConfig = DashboardAppConfig.pages[pageKey];
        if (!pageConfig) {
            console.error(`Page config for key ${pageKey} not found`);
            navigate('/'); // Redirect to home or an error page
            return;
        }

        const requiredRoles = pageConfig.auth || [];
        const hasAccess = requiredRoles.some(role => userRoles.includes(role));
        
        if (!hasAccess) {
            navigate('/'); // Redirect to home or an unauthorized page
        }
    }, [navigate, pageKey]);
};
